<template>
  <div class="all-style-bgc">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoreportInternet">清风论坛></span>
        <span @click="GoreportEvaluation">亦廉课堂></span>
        <span class="red">正文</span>
      </div>
      <!--正文内容-->
      <div class="text">
        <h1>李克强同德国总理举行视频会晤</h1>
        <h2><span class="mg-16">来源：新华社</span>|<span class="mg-16">发布时间：2020-03-30&nbsp;13:30</span></h2>
        <h3 class="title-two">
          <div>韩正召开财税部门座谈会强调</div>
          <div>牢固树立底线思维 抓实抓细政策落地</div>
          <div>确保完成全年经济社会发展目标任务</div>
        </h3>
        <div class="PIC-BOX">
          <img :src="PicBannertest1" alt />
        </div>
        <h3>7月10日，中共中央政治局常委、国务院副总理韩正在财政部召开财税部门座谈会。新华社记者 庞兴雷 摄</h3>
        <h3>新华社北京7月10日电（记者 韩洁）中共中央政治局常委、国务院副总理韩正10日在财政部召开财税部门座谈会。他强调，要以习近平新时代中国特色社会主义思想为指导，认真贯彻党中央、国务院决策部署，贯彻落实全国两会要求，扎实做好“六稳”工作，全面落实“六保”任务，确保完成全年经济社会发展目标任务。</h3>
        <h3>韩正指出，今年以来，财税部门认真贯彻落实积极的财政政策要更加积极有为的要求，各方面工作取得明显成效。下一步，要进一步强化大局观念，加强协同配合，形成政策合力，放大政策效应，为经济平稳运行和社会大局稳定提供有力支撑。</h3>
        <h3>韩正强调，要清醒认识形势，牢固树立底线思维。要坚持稳字当头，坚定信心和决心，把自己的事情做好，在自强中赢得主动，稳住经济基本盘。要落实落细减税降费政策，该减的要减到位，该降的要降到位，抓好资金直达市县基层、直接惠企利民，切实兜牢基层“三保”底线。要坚持以结果为导向，用基层政府、市场主体、人民群众的直接感受来衡量政策落实效果。要管好用好地方政府债券资金，坚持和完善相关制度，稳妥有序化解地方政府债务风险隐患。要支持打好三大攻坚战，确保完成脱贫攻坚目标任务，支持实施区域发展重大战略，有针对性地解决区域发展中面临的新问题。要加大对科技领域的投入，支持科技体制改革，遵循科学规律加强基础研究，聚焦关键核心技术强化重大科技攻关。要从严从紧管好财政支出，加强跟踪监督，提高财政资金使用效益。</h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      PicBannertest1: require("../../../../assets/image/B2-1.jpg"),
      PicBannertest2: require("../../../../assets/image/bannertest2.jpg")
    };
  },
  methods: {
    GoreportInternet() {
      this.$router.push("/forum");
    },
    GoreportEvaluation() {
      this.$router.push({ name: "forumClassroom" });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
/*副导航兰*/
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
/*问卷调查正文*/
.text {
  background-color: white;
  padding: 44px 60px 121px 60px;

  margin: 0 auto;
}
.text h1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}
.text h2 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
  text-align: center;
  padding-bottom: 14px;
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 15px;
}
.text h3 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  text-indent: 2em;
  margin-bottom: 30px;
}
/*静态页面样式 */
.PIC-BOX {
  display: flex;
  justify-content: center;
}

.title-two {
  text-align: center;
  font-weight: bold !important;
  margin-bottom: 0px!important;
}
.mg-16{
  margin: 0px 16px;
}
img{
  margin: 20px 0px;
}
</style>